export default __webpack_public_path__ + "static/media/ctee.2f5d430b.svg";